import QuotationError from './QuotationError';
class QuotationNumberOfBricksLess extends QuotationError {
    constructor(options) {
        super('The number of bricks is zero or negative', options);
    }
}
export default QuotationNumberOfBricksLess;
